import { schema } from 'normalizr';

export const physicianSchema = new schema.Entity('physicians');
